import { endOfWeek, getWeek, startOfWeek } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useCalendarSettings } from '../../../storages';

export const useGetDateTitle = () => {
  const { t } = useTranslation();
  const [{ mode }] = useCalendarSettings();

  return useCallback(
    ({ date, hideWeekNumber }: { date: Date; hideWeekNumber?: boolean }) => {
      switch (mode) {
        case 'day':
          return t('dateFormats.shortMonthDayYear', { date });
        case 'month':
          return t('dateFormats.monthYear', { date });
        case 'week': {
          const weekStart = startOfWeek(date);
          const weekEnd = endOfWeek(date);
          const weekNumber = getWeek(date);

          const startMonth = t('dateFormats.shortMonth', { date: weekStart });
          const endMonth = t('dateFormats.shortMonth', { date: weekEnd });

          const startDay = weekStart.getDate();
          const endDay = weekEnd.getDate();
          const year = weekEnd.getFullYear();

          const weekNumberText = hideWeekNumber ? '' : `(${t('W{{weekNumber}}', { weekNumber })})`;

          const endDateText = startMonth === endMonth ? `${endDay}` : `${endMonth} ${endDay}`;

          return `${startMonth} ${startDay} - ${endDateText}, ${year} ${weekNumberText}`;
        }
      }
    },
    [t, mode],
  );
};
